import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React from 'react';

import Layout from '../../components/Layout';
import LazyText from '../../components/LazyText';

const useStyles = makeStyles({
  alignTop: {
    padding: '24px 20px',
  },
  pageTitleFont: {
    fontSize: 32,
    fontWeight: 'bold',
    margin: 0,
  },
});

const QueueSetupLayout = ({ pageTitle, children }) => {
  const classes = useStyles();
  return (
    <Layout>
      <div className={classes.alignTop}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <LazyText text={pageTitle}>
              <h2 className={classes.pageTitleFont}>{pageTitle}</h2>
            </LazyText>
          </Grid>
          <Grid item xs={12}>
            {children}
          </Grid>
        </Grid>
      </div>
    </Layout>
  );
};

export default QueueSetupLayout;
